import { render, staticRenderFns } from "./ConfirmationMessage.vue?vue&type=template&id=190c19ce&scoped=true&"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prett_26klfa342gafietiguuukji5n4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c19ce",
  null
  
)

export default component.exports